import React from 'react'

export default function SearchBar({placeholder, value, onChange}) {
  return (
    <input
        type="text"
        className="search-bar"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
    />
  )
}
